import React, { useState } from "react"
import { TextField, Autocomplete, Box, CircularProgress } from "@mui/material"

const CustomAutoComplete = React.forwardRef(
  (
    {
      label,
      options = [],
      error,
      helperText,
      optionLabel,
      optionValue,
      setValue,
      selectedValue,
      onChange,
      onInputChange,
      loading,
      renderOptionContent,
      returnObject = false,
    },
    ref
  ) => {
    const [inputValue, setInputValue] = useState("")

    return (
      <Autocomplete
        options={options}
        autoHighlight
        loading={loading}
        value={
          options.find((opt) => opt[optionValue] === selectedValue) || null
        }
        inputValue={inputValue}
        onInputChange={(event, newInputValue, reason) => {
          setInputValue(newInputValue)
          if (onInputChange) {
            onInputChange(newInputValue, event, reason)
          }
        }}
        getOptionLabel={(option) =>
          typeof optionLabel === "function"
            ? optionLabel(option)
            : option[optionLabel] || ""
        }
        onChange={(event, newValue) => {
          setInputValue("")

          if (onInputChange) {
            onInputChange("", event)
          }

          const value = returnObject
            ? newValue || null
            : newValue
              ? newValue[optionValue]
              : ""

          if (onChange) onChange(value)
          if (setValue) setValue(value)
        }}
        renderOption={(props, option) => {
          const { key, ...otherProps } = props
          return (
            <Box
              key={key}
              {...otherProps}
              component="li"
              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
            >
              {renderOptionContent
                ? renderOptionContent(option)
                : option[optionLabel]}
            </Box>
          )
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            error={error}
            helperText={helperText}
            inputRef={ref}
            inputProps={{
              ...params.inputProps,
              autoComplete: "new-password",
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    )
  }
)

export default CustomAutoComplete
